<template>
    <div class="container body fix-footer">
        <div class="row justify-content-center">
            <div class="col-md-8 mt-5 mb-3">
                <div class="card">
                    <div class="card-header">
                        <h3>{{$t('pages.ForgotPassword')}}</h3>
                    </div>
                    <div class="card-body">
                        <div class="alert alert-danger" v-if="error">
                            {{$t(error)}}
                        </div>
                        <form @submit.prevent="submit">
                            <formly-form :form="form" :model="model" :fields="fields" ref="forgotPassword"/>
                            <button type="submit" :class="(disabled ? 'disabled': '') +' btn btn-primary'"
                                    :disabled="disabled">{{ $t('button.Send') }}
                            </button>
                        </form>
                        <vue-recaptcha :sitekey="siteKey"
                                       @expired="onExpired"
                                       @verify="onVerify"
                                       ref="recaptcha"
                                       size="invisible">

                        </vue-recaptcha>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import isEmail from 'validator/lib/isEmail';
  import { ERROR_MESSAGES, SITE_KEY_RECAPTCHA } from '../../constants';
  import VueRecaptcha from 'vue-recaptcha';

  export default {
    name: 'ForgotPassword',
    components: { VueRecaptcha },
    data() {
      return {
        disabled: false,
        error: '',
        form: {},
        siteKey: SITE_KEY_RECAPTCHA,
        model: {
          email: '',
        },
        fields: [
          {
            key: 'email',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.Email')
            },
            required: true,
            validators: {
              validEmail: {
                expression(field, model, next) {
                  next(isEmail(model[field.key]));
                },
                message: this.$t('validation.email')
              }
            }
          }
        ]
      };
    },
    methods: {
      ...mapActions(['forgotPassword']),
      submit() {
        this.error = null;
        this.$refs.forgotPassword.validate()
          .then(() => {
            if (!this.form.$valid) return;
            this.disabled = true;

            this.$refs.recaptcha.execute();
          }, (err) => {

          });
      },
      onExpired() {
        this.error = ERROR_MESSAGES.INTERNAL_SERVER_ERROR;
      },
      onVerify(response) {
        return this.forgotPassword({
          ...this.model,
          'recaptcha': response
        })
          .then(() => {
            this.$router.push('/forgot-password/success');
          })
          .catch((e) => {
            this.$refs.recaptcha.reset();
            this.disabled = false;
            if (e.response.data && e.response.data.message) {
              this.error =  'errorMessages.' + e.response.data.message;
            } else {
              this.error = ERROR_MESSAGES.INTERNAL_SERVER_ERROR;
            }
          });
      }
    }
  };
</script>

<style scoped>

</style>
